module.exports = __webpack_public_path__ + "img/about-patent10.fc55022.png";